// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  box-sizing: border-box;
}

body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, sans-serif;
  background-color: #f5f5f5;
  color: #333;
}

.container {
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
  text-align: center;
}

h1 {
  color: #2c3e50;
  margin-bottom: 30px;
}

.video-container {
  position: relative;
  display: inline-block;
  margin: 20px auto;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

#video {
  display: block;
  transform: scaleX(-1);
}

#overlay {
  position: absolute;
  top: 0;
  left: 0;
  transform: scaleX(-1);
}

.controls {
  margin: 20px 0;
}

.mode-selector {
  margin-bottom: 15px;
  padding: 15px;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.mode-selector label {
  margin: 0 15px;
  cursor: pointer;
  font-size: 14px;
}

.mode-selector input[type="radio"] {
  margin-right: 5px;
  cursor: pointer;
}

.threshold-control {
  margin-top: 15px;
  padding: 15px;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.threshold-control label {
  display: block;
  margin-bottom: 10px;
  font-weight: 500;
  font-size: 14px;
}

.threshold-control input[type="range"] {
  width: 100%;
  max-width: 300px;
  margin: 0 auto;
  display: block;
}

#thresholdValue {
  color: #3498db;
  font-weight: bold;
}

.btn {
  padding: 10px 20px;
  margin: 0 10px;
  border: none;
  border-radius: 5px;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.btn-primary {
  background-color: #3498db;
  color: white;
}

.btn-primary:hover:not(:disabled) {
  background-color: #2980b9;
}

.btn-secondary {
  background-color: #e74c3c;
  color: white;
}

.btn-secondary:hover:not(:disabled) {
  background-color: #c0392b;
}

.btn-snapshot {
  background-color: #27ae60;
  color: white;
}

.btn-snapshot:hover:not(:disabled) {
  background-color: #219a52;
}

.stats {
  background-color: white;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  margin-top: 20px;
}

.stats p {
  margin: 10px 0;
  font-size: 14px;
}

.error {
  background-color: #fee;
  color: #c33;
  padding: 20px;
  border-radius: 8px;
  margin: 20px auto;
  max-width: 600px;
}

.loading {
  text-align: center;
  padding: 50px;
}

.loading h2 {
  color: #666;
}

@media (max-width: 768px) {
  .container {
    padding: 10px;
  }

  .video-container {
    width: 100%;
    max-width: 400px;
  }

  #video, #overlay {
    width: 100%;
    height: auto;
  }

  .btn {
    padding: 8px 16px;
    font-size: 14px;
  }
}

/* Pro Mode Styles */
.pro-controls {
  margin-top: 15px;
  padding: 15px;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  text-align: left;
}

.pro-controls h3 {
  margin: 0 0 15px 0;
  color: #2c3e50;
  font-size: 16px;
  text-align: center;
}

.pro-controls label {
  display: block;
  margin: 8px 0;
  cursor: pointer;
  font-size: 14px;
  padding: 5px 0;
}

.pro-controls label:hover {
  color: #3498db;
}

.pro-controls input[type="checkbox"] {
  margin-right: 8px;
  cursor: pointer;
  width: 16px;
  height: 16px;
}

/* Pro mode canvas styling */
.video-container.pro-mode {
  border: 2px solid #3498db;
  box-shadow: 0 0 20px rgba(52, 152, 219, 0.3);
}

/* Animation for landmark transitions */
@keyframes pulse {
  0% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(1.1);
    opacity: 0.8;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

.landmark-point {
  animation: pulse 2s ease-in-out infinite;
}

/* Expression labels styling */
.expression-label {
  background-color: rgba(0, 0, 0, 0.8);
  color: white;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: bold;
}

/* Stats styling for pro mode */
.stats.pro-mode {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
}

.stats.pro-mode p {
  color: white;
}

.stats.pro-mode strong {
  color: #ffd700;
}

/* Camera Selector Styles */
.camera-selector {
  margin: 10px 0;
  padding: 10px;
  background: #f9f9f9;
  border-radius: 5px;
}

.camera-selector label {
  display: inline-block;
  margin-right: 10px;
  font-weight: bold;
}

.camera-selector select {
  padding: 5px 10px;
  border: 1px solid #ddd;
  border-radius: 3px;
  background: white;
  font-size: 14px;
  cursor: pointer;
  min-width: 200px;
}

.camera-selector select:hover {
  border-color: #3498db;
}

.camera-selector select:focus {
  outline: none;
  border-color: #3498db;
  box-shadow: 0 0 0 2px rgba(52, 152, 219, 0.2);
}`, "",{"version":3,"sources":["webpack://./src/styles.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,yGAAyG;EACzG,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;AACF;;AAEA,oBAAoB;AACpB;EACE,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,WAAW;EACX,YAAY;AACd;;AAEA,4BAA4B;AAC5B;EACE,yBAAyB;EACzB,4CAA4C;AAC9C;;AAEA,uCAAuC;AACvC;EACE;IACE,mBAAmB;IACnB,UAAU;EACZ;EACA;IACE,qBAAqB;IACrB,YAAY;EACd;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;AACF;;AAEA;EACE,wCAAwC;AAC1C;;AAEA,8BAA8B;AAC9B;EACE,oCAAoC;EACpC,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA,+BAA+B;AAC/B;EACE,6DAA6D;EAC7D,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA,2BAA2B;AAC3B;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C","sourcesContent":["* {\n  box-sizing: border-box;\n}\n\nbody {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, sans-serif;\n  background-color: #f5f5f5;\n  color: #333;\n}\n\n.container {\n  max-width: 800px;\n  margin: 0 auto;\n  padding: 20px;\n  text-align: center;\n}\n\nh1 {\n  color: #2c3e50;\n  margin-bottom: 30px;\n}\n\n.video-container {\n  position: relative;\n  display: inline-block;\n  margin: 20px auto;\n  border-radius: 8px;\n  overflow: hidden;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n}\n\n#video {\n  display: block;\n  transform: scaleX(-1);\n}\n\n#overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  transform: scaleX(-1);\n}\n\n.controls {\n  margin: 20px 0;\n}\n\n.mode-selector {\n  margin-bottom: 15px;\n  padding: 15px;\n  background-color: white;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.mode-selector label {\n  margin: 0 15px;\n  cursor: pointer;\n  font-size: 14px;\n}\n\n.mode-selector input[type=\"radio\"] {\n  margin-right: 5px;\n  cursor: pointer;\n}\n\n.threshold-control {\n  margin-top: 15px;\n  padding: 15px;\n  background-color: white;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.threshold-control label {\n  display: block;\n  margin-bottom: 10px;\n  font-weight: 500;\n  font-size: 14px;\n}\n\n.threshold-control input[type=\"range\"] {\n  width: 100%;\n  max-width: 300px;\n  margin: 0 auto;\n  display: block;\n}\n\n#thresholdValue {\n  color: #3498db;\n  font-weight: bold;\n}\n\n.btn {\n  padding: 10px 20px;\n  margin: 0 10px;\n  border: none;\n  border-radius: 5px;\n  font-size: 16px;\n  cursor: pointer;\n  transition: background-color 0.3s;\n}\n\n.btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.btn-primary {\n  background-color: #3498db;\n  color: white;\n}\n\n.btn-primary:hover:not(:disabled) {\n  background-color: #2980b9;\n}\n\n.btn-secondary {\n  background-color: #e74c3c;\n  color: white;\n}\n\n.btn-secondary:hover:not(:disabled) {\n  background-color: #c0392b;\n}\n\n.btn-snapshot {\n  background-color: #27ae60;\n  color: white;\n}\n\n.btn-snapshot:hover:not(:disabled) {\n  background-color: #219a52;\n}\n\n.stats {\n  background-color: white;\n  padding: 20px;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  margin-top: 20px;\n}\n\n.stats p {\n  margin: 10px 0;\n  font-size: 14px;\n}\n\n.error {\n  background-color: #fee;\n  color: #c33;\n  padding: 20px;\n  border-radius: 8px;\n  margin: 20px auto;\n  max-width: 600px;\n}\n\n.loading {\n  text-align: center;\n  padding: 50px;\n}\n\n.loading h2 {\n  color: #666;\n}\n\n@media (max-width: 768px) {\n  .container {\n    padding: 10px;\n  }\n\n  .video-container {\n    width: 100%;\n    max-width: 400px;\n  }\n\n  #video, #overlay {\n    width: 100%;\n    height: auto;\n  }\n\n  .btn {\n    padding: 8px 16px;\n    font-size: 14px;\n  }\n}\n\n/* Pro Mode Styles */\n.pro-controls {\n  margin-top: 15px;\n  padding: 15px;\n  background-color: white;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  text-align: left;\n}\n\n.pro-controls h3 {\n  margin: 0 0 15px 0;\n  color: #2c3e50;\n  font-size: 16px;\n  text-align: center;\n}\n\n.pro-controls label {\n  display: block;\n  margin: 8px 0;\n  cursor: pointer;\n  font-size: 14px;\n  padding: 5px 0;\n}\n\n.pro-controls label:hover {\n  color: #3498db;\n}\n\n.pro-controls input[type=\"checkbox\"] {\n  margin-right: 8px;\n  cursor: pointer;\n  width: 16px;\n  height: 16px;\n}\n\n/* Pro mode canvas styling */\n.video-container.pro-mode {\n  border: 2px solid #3498db;\n  box-shadow: 0 0 20px rgba(52, 152, 219, 0.3);\n}\n\n/* Animation for landmark transitions */\n@keyframes pulse {\n  0% {\n    transform: scale(1);\n    opacity: 1;\n  }\n  50% {\n    transform: scale(1.1);\n    opacity: 0.8;\n  }\n  100% {\n    transform: scale(1);\n    opacity: 1;\n  }\n}\n\n.landmark-point {\n  animation: pulse 2s ease-in-out infinite;\n}\n\n/* Expression labels styling */\n.expression-label {\n  background-color: rgba(0, 0, 0, 0.8);\n  color: white;\n  padding: 4px 8px;\n  border-radius: 4px;\n  font-size: 12px;\n  font-weight: bold;\n}\n\n/* Stats styling for pro mode */\n.stats.pro-mode {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n}\n\n.stats.pro-mode p {\n  color: white;\n}\n\n.stats.pro-mode strong {\n  color: #ffd700;\n}\n\n/* Camera Selector Styles */\n.camera-selector {\n  margin: 10px 0;\n  padding: 10px;\n  background: #f9f9f9;\n  border-radius: 5px;\n}\n\n.camera-selector label {\n  display: inline-block;\n  margin-right: 10px;\n  font-weight: bold;\n}\n\n.camera-selector select {\n  padding: 5px 10px;\n  border: 1px solid #ddd;\n  border-radius: 3px;\n  background: white;\n  font-size: 14px;\n  cursor: pointer;\n  min-width: 200px;\n}\n\n.camera-selector select:hover {\n  border-color: #3498db;\n}\n\n.camera-selector select:focus {\n  outline: none;\n  border-color: #3498db;\n  box-shadow: 0 0 0 2px rgba(52, 152, 219, 0.2);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
